import { module as BaseModule } from 'modujs';
import SplitType from 'split-type';
import gsap from 'gsap';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.iObs = null;
    this.splittedHeading = null;
    this.heading = this.$('heading')[0];
    this.text = this.$('text')[0];
    this.ecosystem = this.$('ecosystem')[0];
  }

  init() {
    this.splitHeading();
    this.setupIntersectionObserver();
  }

  splitHeading() {
    this.splittedHeading = new SplitType( this.heading, {
      types: 'lines',
      lineClass: 'o-line',
    });
  }

  setupIntersectionObserver() {
    if ( ! window.IntersectionObserver ) {
      return;
    }

    this.iObs = new IntersectionObserver(
      entries => this.handleIntersection( entries ),
      {
        threshold: [ 0.5 ],
      }
    );

    this.iObs.observe( this.heading );
    this.$('counter').forEach( counter =>
      this.iObs.observe( counter )
    );
    this.iObs.observe( this.ecosystem );
  }

  handleIntersection( entries ) {
    entries.forEach( (entry, self) => {
      if ( entry.isIntersecting ) {
        if ( 'heading' === entry.target.dataset.intro ) {
          this.animateText();
        } else if ( 'counter' === entry.target.dataset.intro ) {
          setTimeout(() => {
            this.animateCounter( entry.target );
          }, 500);
        } else if ( entry.target === this.ecosystem ) {
          this.ecosystem.firstElementChild.play();
        }
        this.iObs.unobserve( entry.target );
      }
    } );
  }

  animateText() {
    gsap.to( this.splittedHeading.lines, {
      duration: 0.8,
      opacity: 1,
      y: 0,
      stagger: 0.25,
      ease: 'power3.out',
      onComplete: () => {
        this.splittedHeading.revert();
      }
    } );

    gsap.to( this.text, {
      duration: 1,
      delay: 0.8,
      opacity: 1,
      ease: 'power3.out',
    } );
  }

  animateCounter(element) {
    let counter = 0;
    let increment = 1;

    gsap.to( element.parentElement, {
      duration: 1,
      opacity: 1,
      ease: 'power3.out',
    } );

    const matches = /(\+)?(\d+)(\s?\w+)?/.exec(element.dataset.count);
    const before = matches[1] ?? '';
    const after = matches[3] ?? '';

    if (matches[2] > 1000) {
      increment = 50;
    } else if (matches[2] > 500) {
      increment = 20;
    } else if (matches[2] > 100) {
      increment = 10;
    }

    const step = timestamp => {
      counter += increment;

      element.innerText = `${before}${counter.toLocaleString()}${after}`;

      if (counter < +matches[2]) {
        window.requestAnimationFrame( step );
      } else {
        // Ensure the final number is exact
        element.innerText = `${before}${(+matches[2]).toLocaleString()}${after}`;
      }
    };

    window.requestAnimationFrame( step );
  }
}
